/**
 * Campaign Slug Persistence Service
 *
 * Mirrors guestDraftService: stores the campaign slug in sessionStorage so it
 * survives the same-tab MSAL redirect to Entra and back, then clears after
 * successful checkout or explicit discard.
 */

import { CAMPAIGN_SLUG_STORAGE_KEY } from '../constants/subscriptionCampaigns';

/**
 * Saves a campaign slug for post-signup checkout attribution.
 */
export const saveCampaignSlug = (slug: string): void => {
  try {
    sessionStorage.setItem(CAMPAIGN_SLUG_STORAGE_KEY, slug);
  } catch {
    console.error('Failed to save campaign slug');
  }
};

/**
 * Loads the persisted campaign slug, or null if none / unavailable.
 */
export const loadCampaignSlug = (): string | null => {
  try {
    return sessionStorage.getItem(CAMPAIGN_SLUG_STORAGE_KEY);
  } catch {
    return null;
  }
};

/**
 * Removes the persisted campaign slug after checkout or discard.
 */
export const clearCampaignSlug = (): void => {
  try {
    sessionStorage.removeItem(CAMPAIGN_SLUG_STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
};

/**
 * Returns true when a campaign slug is present in sessionStorage.
 */
export const hasCampaignSlug = (): boolean => {
  try {
    return sessionStorage.getItem(CAMPAIGN_SLUG_STORAGE_KEY) !== null;
  } catch {
    return false;
  }
};
